import { useState, useEffect } from "react";
import { Col } from "react-bootstrap";
import { FiLink } from "react-icons/fi";

export const ProjectCard = ({
  id,
  title,
  description,
  imgUrl,
  technologies,
  projectUrl,
  isFlipped,
  onFlip
}) => {
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    // Check if device is touch-enabled or has tablet screen size (up to 1024px)
    const checkIfTouchDevice = () => {
      setIsTouchDevice(
        window.innerWidth <= 1024 || // Covers tablets and smaller
        'ontouchstart' in window || // Touch screen detection
        navigator.maxTouchPoints > 0
      );
    };
    
    checkIfTouchDevice();
    window.addEventListener("resize", checkIfTouchDevice);
    return () => window.removeEventListener("resize", checkIfTouchDevice);
  }, []);

  const handleClick = () => {
    if (isTouchDevice) {
      onFlip();
    }
  };

  return (
    <Col xs={12} sm={6} md={4} className="mb-4">
      <div
        className={`flip-card ${isFlipped ? "flipped" : ""}`}
        onClick={handleClick}
      >
        <div className="flip-card-inner">
          <div className="flip-card-front">
            <img src={imgUrl} alt={title} />
            <h4>{title}</h4>
          </div>
          <div className="flip-card-back">
            <h5>{description}</h5>
            <p>{technologies}</p>
            {projectUrl && (
              <a
                href={projectUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="view-link"
                onClick={(e) => e.stopPropagation()}
              >
                <FiLink size={24} />
              </a>
            )}
          </div>
        </div>
      </div>
    </Col>
  );
};